import StoredLayout from '../../layouts/StoredLayout'
import FontAwesome from './FontAwesome'
export default StoredLayout(FontAwesome)
